import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import EdTreeNode from './ed-tree-node.vue';

@Component({
  components: {
    EdTreeNode,
  },
})
class EdTreeViewContainer extends Vue {
  @Prop({ type: Array, required: true }) items!: any[];
  @Prop({ type: String, default: 'id' }) itemKey!: string;
  @Prop({ type: Array, default: () => [] }) open!: string[];
}

export default Vue.component('ed-treeview-container', EdTreeViewContainer);